import { render, staticRenderFns } from "./voiceConvert.vue?vue&type=template&id=0c61c350&scoped=true"
import script from "./voiceConvert.vue?vue&type=script&lang=js"
export * from "./voiceConvert.vue?vue&type=script&lang=js"
import style0 from "./voiceConvert.vue?vue&type=style&index=0&id=0c61c350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c61c350",
  null
  
)

export default component.exports